import {
  ChangeDetectorRef,
  Component,
  input,
  Input,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MatchDetailLive } from '../../models/match-data.models';
import { ParamsModel } from '../../models/params.model';
import { MatchDataService } from '../../services/match-data.service';
import { environment } from '../../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { DashboardInfoComponent } from './dashboard-info/dashboard-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { TabBarComponent } from '../../../../components/shared/tab-bar/tab-bar.component';

@Component({
  selector: 'app-h2h',
  standalone: true,
  imports: [
    CommonModule,
    NzSkeletonComponent,
    DashboardInfoComponent,
    TranslateModule,
    TabBarComponent,
  ],
  templateUrl: './h2h.component.html',
  styleUrl: './h2h.component.scss',
})
export class H2hComponent {
  @Input() set infoMatchSelected(infoMatchSelected: any) {
    this.infoMatch = infoMatchSelected;
  }

  matchId = input<string>();
  sport = input<string>();

  optionFilterSelected: any = 0;
  infoMatch: MatchDetailLive = {} as MatchDetailLive;

  h2hStatics: {
    status: boolean;
    homeInfo: any[];
    awayInfo: any[];
    homeVSaway: any[];
    homeInfoFilter: any[];
    awayInfoFilter: any[];
    homeVSawayFilter: any[];
    awayVsHomeFilter: any[];
  } = {
    status: false,
    homeInfo: [],
    awayInfo: [],
    homeVSaway: [],
    homeInfoFilter: [],
    awayInfoFilter: [],
    homeVSawayFilter: [],
    awayVsHomeFilter: [],
  };

  params: ParamsModel = {} as ParamsModel;
  loadingHome = true;
  loadingAway = true;
  loadingVs = true;

  firstLoad: boolean = true;
  public moreHome: boolean = true;
  public moreAway: boolean = true;
  public moreVs: boolean = true;

  urlIMG = environment.urlIMG;

  constructor(
    private readonly matchServices: MatchDataService,
    private readonly _activateRoute: ActivatedRoute,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._activateRoute.params.subscribe((params: any) => {
      this.params = params;
    });
    this.getInfoH2H();
  }

  menuSelected(event: number) {
    this.optionFilterSelected = event;
  }

  private getInfoH2H() {
    if (this.firstLoad) {
      this.firstLoad = false;
      this.matchServices
        .getH2HMatch(
          this.matchId() && this.sport()
            ? ({ id: this.matchId()!, sport: this.sport() } as any)
            : this.params
        )
        .subscribe(
          (result: any) => {
            if (result.status) {
              this.ref.detectChanges();
              this.loadLastMatchesHome(result.h2h);
              this.loadLastMatchesAway(result.h2h);
              this.loadLastMatchesVs(result.h2h);
              if (result.h2h?.homeInfo?.length <= 0) {
                this.loadingHome = false;
                this.loadingAway = false;
                this.loadingVs = false;
              }
            } else {
              this.loadingHome = false;
              this.loadingAway = false;
              this.loadingVs = false;
            }
          },
          () => {
            this.h2hStatics = {
              status: false,
              homeInfo: [],
              awayInfo: [],
              homeVSaway: [],
              homeInfoFilter: [],
              awayInfoFilter: [],
              homeVSawayFilter: [],
              awayVsHomeFilter: [],
            };
            this.loadingHome = false;
            this.loadingAway = false;
            this.loadingVs = false;
          }
        );
    }
  }

  private loadLastMatchesHome(response: any) {
    for (let i = 0; i < response.homeInfo.length; i++) {
      const id =
        response.homeInfo[i].dataHome.id === response.homeId
          ? response.homeInfo[i].dataAway.id
          : response.homeInfo[i].dataHome.id;
      this.matchServices
        .getTeamData(this.params, id)
        .subscribe((result: any) => {
          response.homeInfo[i].dataHome.name =
            response.homeInfo[i].dataHome.id === response.homeId
              ? this.infoMatch.homeTeam.name
              : result.team.name;
          response.homeInfo[i].dataAway.name =
            response.homeInfo[i].dataAway.id === response.homeId
              ? this.infoMatch.homeTeam.name
              : result.team.name;

          if (response.homeInfo[i].dataHome.id === response.homeId) {
            response.homeInfo[i].dataHome.logo =
              this.infoMatch.homeTeam.national === 0
                ? this.infoMatch.homeTeam.logo
                : this.infoMatch.homeTeam.country_logo != ''
                ? this.infoMatch.homeTeam.country_logo
                : this.infoMatch.homeTeam.logo;
          } else {
            response.homeInfo[i].dataHome.logo =
              result.team.national === 0
                ? result.team.logo
                : result.team.country_logo != ''
                ? result.team.country_logo
                : result.team.logo;
          }
          if (response.homeInfo[i].dataAway.id === response.homeId) {
            response.homeInfo[i].dataAway.logo =
              this.infoMatch.homeTeam.national === 0
                ? this.infoMatch.homeTeam.logo
                : this.infoMatch.homeTeam.country_logo != ''
                ? this.infoMatch.homeTeam.country_logo
                : this.infoMatch.homeTeam.logo;
          } else {
            response.homeInfo[i].dataAway.logo =
              result.team.national === 0
                ? result.team.logo
                : result.team.country_logo != ''
                ? result.team.country_logo
                : result.team.logo;
          }
          this.h2hStatics.homeInfo.push(response.homeInfo[i]);
          this.h2hStatics.homeInfoFilter = this.h2hStatics.homeInfo.filter(
            (elem: any) => elem.dataHome.id === response.homeId
          );
          this.loadingHome = false;
          this.ref.markForCheck();
        });
    }
  }

  private loadLastMatchesAway(response: any) {
    for (let i = 0; i < response.awayInfo.length; i++) {
      const id =
        response.awayInfo[i].dataHome.id === response.awayId
          ? response.awayInfo[i].dataAway.id
          : response.awayInfo[i].dataHome.id;
      this.matchServices
        .getTeamData(this.params, id)
        .subscribe((result: any) => {
          response.awayInfo[i].dataHome.name =
            response.awayInfo[i].dataHome.id === response.awayId
              ? this.infoMatch.awayTeam?.name
              : result.team?.name;
          response.awayInfo[i].dataAway.name =
            response.awayInfo[i].dataAway.id === response.awayId
              ? this.infoMatch.awayTeam?.name
              : result.team?.name;

          if (response.awayInfo[i].dataHome.id === response.awayId) {
            response.awayInfo[i].dataHome.logo =
              this.infoMatch.awayTeam.national === 0
                ? this.infoMatch.awayTeam.logo
                : this.infoMatch.awayTeam.country_logo != ''
                ? this.infoMatch.awayTeam.country_logo
                : this.infoMatch.awayTeam.logo;
          } else {
            response.awayInfo[i].dataHome.logo =
              result.team.national === 0
                ? result.team.logo
                : result.team.country_logo != ''
                ? result.team.country_logo
                : result.team.logo;
          }
          if (response.awayInfo[i].dataAway.id === response.awayId) {
            response.awayInfo[i].dataAway.logo =
              this.infoMatch.awayTeam.national === 0
                ? this.infoMatch.awayTeam.logo
                : this.infoMatch.awayTeam.country_logo != ''
                ? this.infoMatch.awayTeam.country_logo
                : this.infoMatch.awayTeam.logo;
          } else {
            response.awayInfo[i].dataAway.logo =
              result.team.national === 0
                ? result.team.logo
                : result.team.country_logo != ''
                ? result.team.country_logo
                : result.team.logo;
          }

          this.h2hStatics.awayInfo.push(response.awayInfo[i]);
          this.h2hStatics.awayInfoFilter = this.h2hStatics.awayInfo.filter(
            (elem: any) => elem.dataAway.id === response.awayId
          );
          this.loadingAway = false;
          this.ref.markForCheck();
        });
    }
  }

  private loadLastMatchesVs(response: any) {
    for (let i = 0; i < response.homeVSaway.length; i++) {
      if (response.homeVSaway[i].dataHome.id === response.homeId) {
        response.homeVSaway[i].dataHome.name = this.infoMatch.homeTeam.name;
        response.homeVSaway[i].dataHome.logo =
          this.infoMatch.homeTeam.national === 0
            ? this.infoMatch.homeTeam.logo
            : this.infoMatch.homeTeam.country_logo != ''
            ? this.infoMatch.homeTeam.country_logo
            : this.infoMatch.homeTeam.logo;
      } else if (response.homeVSaway[i].dataAway.id === response.homeId) {
        response.homeVSaway[i].dataAway.name = this.infoMatch.homeTeam.name;
        response.homeVSaway[i].dataAway.logo =
          this.infoMatch.homeTeam.national === 0
            ? this.infoMatch.homeTeam.logo
            : this.infoMatch.homeTeam.country_logo != ''
            ? this.infoMatch.homeTeam.country_logo
            : this.infoMatch.homeTeam.logo;
      }

      if (response.homeVSaway[i].dataHome.id === response.awayId) {
        response.homeVSaway[i].dataHome.name = this.infoMatch.awayTeam.name;
        response.homeVSaway[i].dataHome.logo =
          this.infoMatch.awayTeam.national === 0
            ? this.infoMatch.awayTeam.logo
            : this.infoMatch.awayTeam.country_logo != ''
            ? this.infoMatch.awayTeam.country_logo
            : this.infoMatch.awayTeam.logo;
      } else if (response.homeVSaway[i].dataAway.id === response.awayId) {
        response.homeVSaway[i].dataAway.name = this.infoMatch.awayTeam.name;
        response.homeVSaway[i].dataAway.logo =
          this.infoMatch.awayTeam.national === 0
            ? this.infoMatch.awayTeam.logo
            : this.infoMatch.awayTeam.country_logo != ''
            ? this.infoMatch.awayTeam.country_logo
            : this.infoMatch.awayTeam.logo;
      }

      this.h2hStatics.homeVSaway.push(response.homeVSaway[i]);
      this.h2hStatics.homeVSawayFilter = this.h2hStatics.homeVSaway.filter(
        (elem: any) =>
          elem.dataHome.id === response.homeId ||
          elem.dataAway.id === response.homeId
      );
      this.h2hStatics.awayVsHomeFilter = this.h2hStatics.homeVSaway.filter(
        (elem: any) =>
          elem.dataAway.id === response.awayId ||
          elem.dataHome.id === response.awayId
      );
      this.loadingVs = false;
      this.ref.markForCheck();
    }
  }
}
